import React, { useState } from "react";
import EmailLoginManager from "./EmailLoginManager";
import { Form, Input, Button, Icon } from "semantic-ui-react";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

type EmailLoginProps = {
  onBack?: () => void;
  onRegister?: (email: string) => void;
};

const Login = (props: EmailLoginProps) => {
  const history = useHistory();
  const intl = useIntl();
  const manager = new EmailLoginManager();
  let [email, setEmail] = useState("");
  let [message, setMessage] = useState("");
  let [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onLogin = async () => {
    setMessage("");
    setErrorMessage("");
    setIsLoading(true);
    try {
      let ret = await manager.requestLogin(email);
      setMessage(ret.detail);
      setIsLoading(false);
    } catch (e) {
      console.log("e", e);
      if (e.response.status === 404) {
        if (props.onRegister) {
          props.onRegister(email);
        } else {
          history.push("/EmailRegister/", { email: email });
        }
      }
      setErrorMessage(JSON.stringify(e.response.data));
      setIsLoading(false);
    }
  };

  return (
    <div style={{ height: "100vh", padding: "3rem" }}>
      {props.onBack && (
        <Button basic icon onClick={props.onBack}>
          <Icon name="arrow left" />
          {intl.formatMessage({ id: "กลับ" }, { defaultMessage: "กลับ" })}
        </Button>
      )}

      <h2>{intl.formatMessage({ id: "เข้าสู่ระบบ" }, { defaultMessage: "Login" })}</h2>
      <ErrorMessage error={errorMessage} />
      <ErrorMessage success={message} />
      <Form>
        <Form.Group>
          <Form.Field width={16}>
            <label htmlFor="inputEmail">
              {intl.formatMessage({ id: "อีเมล" }, { defaultMessage: "Email address" })}
            </label>
            <Input
              type="email"
              className="form-control"
              id="inputEmail"
              value={email}
              placeholder={intl.formatMessage(
                { id: "กรุณากรอกอีเมล" },
                { defaultMessage: "Enter your email" }
              )}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Field>
        </Form.Group>
      </Form>
      <Button primary loading={isLoading} disabled={isLoading} onClick={onLogin}>
        {intl.formatMessage({ id: "เข้าสู่ระบบ" }, { defaultMessage: "Login" })}
      </Button>
    </div>
  );
};

export default Login;
